import React from "react";

const Cookie_Policy = () => {
  return (
    <>
   <section className="privacy-policy-sec sec">
  <div className="container">
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="privacy-policy-txt-main">
          <div className="privacy-policy-txt">
            <h2 className="text-center">Privacy Policy</h2>
            <p>
              At <strong>The Design Showroom Ltd</strong>, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you interact with our website, showroom, and services.</p>
          </div>
          <div className="privacy-policy-txt">
            <h2>Information We Collect</h2>
            <p>
              We may collect and process the following information:
            </p>
            <div className="privacy-policy-list">
              <ul>
                <li>
                  <p>
                    Personal details such as your name, email address, phone number, and postal address when you contact us or make an enquiry.
                  </p>
                </li>
                <li>
                  <p>
                    Transaction details including payments and purchase history.
                  </p>
                </li>
                <li>
                  <p>
                    Technical information such as IP address, browser type, and browsing behaviour when using our website.
                  </p>
                </li>
                <li>
                  <p>
                    Marketing preferences when you subscribe to newsletters or updates.
                  </p>
                </li>
              </ul>
            </div>
            <h4>How We Use Your Information</h4>
            <p>We use your data to:</p>
            <div className="privacy-policy-list">
              <ul>
                <li><p>Process enquiries, orders, and payments.</p></li>
                <li><p>Deliver products and provide installation or after-sales support.</p></li>
                <li><p>Improve our website, services, and customer experience.</p></li>
                <li><p>Send you updates, offers, or newsletters (only if you have opted in).</p></li>
                <li><p>Comply with legal obligations and resolve disputes.</p></li>
              </ul>
            </div>
            <h2>Data Sharing and Security</h2>
            <p>We do not sell your personal data. Information may be shared with trusted third-party providers (e.g., delivery partners, payment processors) only where necessary to fulfil our services. We implement appropriate technical and organisational measures to protect your data from unauthorised access, loss, or misuse.</p>
            <h2>Cookies</h2>
            <p>Our website may use cookies to improve user experience, track performance, and tailor content. You can manage or disable cookies through your browser settings.</p>
            <h2>Your Rights (GDPR)</h2>
            <p>Under UK GDPR, you have the right to:</p>
            <div className="privacy-policy-list">
              <ul>
                <li><p>Access, correct, or delete your personal data.</p></li>
                <li><p>Restrict or object to processing.</p></li>
                <li><p>Withdraw consent at any time (for marketing communications).</p></li>
                <li><p>Lodge a complaint with the Information Commissioner’s Office (ICO).</p></li>
              </ul>
            </div>
          </div>
          <div className="privacy-policy-txt">
            <h2>Contact Us</h2>
            <h6>If you have questions about this Privacy Policy or how your data is handled, please contact us at:</h6>
            <div className="privacy-policy-con">
              <h6>Email: </h6>
              <a href="mailto:sales@thedesignshowroom.com">sales@thedesignshowroom.com</a>
            </div>
            <div className="privacy-policy-con">
              <h6>Website:</h6>
              <a href="https://www.thedesignshowroom.com/">www.thedesignshowroom.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


    </>
  );
};

export default Cookie_Policy;
